import { Field } from 'formik';

import { BaseCheckbox } from '../BaseCheckbox/BaseCheckbox';

export const CheckboxField = ({ name, checked, onChange, text, label }) => (
  <Field component={BaseCheckbox} name={name} label={label} checked={checked} onChange={onChange} data-testid={name}>
    {text}
  </Field>
);

export default CheckboxField;
